import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectAiChatConfigurationsState = createSelector(
  getSystem,
  ({ aiChatConfigurations }) => aiChatConfigurations,
);

export const selectAiChatConfigurations = createSelector(
  selectAiChatConfigurationsState,
  ({ configurations }) => configurations,
);

export const selectAiChatConfigurationTemplates = createSelector(
  selectAiChatConfigurationsState,
  ({ templates }) => templates,
);

export const selectConfigurationsWithEnabledTemplates = createSelector(
  [selectAiChatConfigurations, selectAiChatConfigurationTemplates],
  (configurations, templates) => [
    ...configurations.map(configuration => ({
      ...configuration,
      isTemplate: false,
      isEnabled: true,
    })),
    ...templates
      .filter(template => template.isEnabled)
      .map(template => ({ ...template, isTemplate: true })),
  ],
);

export const selectAiChatConfigurationById = id =>
  createSelector(selectConfigurationsWithEnabledTemplates, items =>
    items.find(config => config.id === id),
  );
